module.exports = __webpack_public_path__ + "img/carousel-productos-5.839c4761.jpg";